import React from 'react'
import PropTypes from 'prop-types'
import { FAQ } from 'components/FAQ'
import FAQItem from 'components/FaqItem'
import { View } from 'components/View'
import markdownToHtmlStringUtil from 'utils/string/markdown-to-html'

export function CheckExerciseFormSlugFAQ ({ faqs }) {
  console.log('[CheckExerciseFormSlugFAQ] faqs:', faqs)
  console.log('[CheckExerciseFormSlugFAQ] has FAQs:', !!(faqs && Array.isArray(faqs) && faqs.length > 0))

  // Only render if we have FAQs
  if (!faqs || !Array.isArray(faqs) || faqs.length === 0) {
    return null
  }

  return (
    // eslint-disable-next-line react/jsx-pascal-case
    <FAQ
      itemsComponent={(
        <View>
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={<div style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: markdownToHtmlStringUtil(faq.answer) }} />}
            />
          ))}
        </View>
      )}
    />
  )
}

CheckExerciseFormSlugFAQ.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired
  }))
}
